
const AUTH_BASE_URL = 'https://apigateway.irantarakonesh.ir:443';
const API_BASE_URL = 'https://apigateway.irantarakonesh.ir:443';

interface TokenResponse {
    access_token: string;
    token_type?: string;
    expires_in?: number;
}

interface SepShareTokenResponse {
    token?: string;
    [key: string]: any;
}


export const generateClientRequestId = (): string => {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
        return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};


export const getAuthToken = async (clientRequestId: string): Promise<TokenResponse> => {
    const formData = new FormData();
    formData.append('client_id', `HashinGoldClient`); 
    formData.append('client_secret', 'frc48Lr8kIvFyd0myqvOgReAeH9Be1d1y0s');
    formData.append('grant_type', 'client_credentials');
    formData.append('scope', '');

    const response = await fetch(`${AUTH_BASE_URL}/Auth/token`, {
        method: 'POST',
        headers: {
            Authorization: `Basic 9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a08`,
        },
        body: formData,
    });

    if (!response.ok) {
        throw new Error(`خطا در دریافت توکن: ${response.status}`);
    }

    return response.json();
};

export const getSepShareToken = async (
    bearerToken: string,
    resNum: number | string
): Promise<SepShareTokenResponse> => {
    const response = await fetch(`${API_BASE_URL}/api/v1/Token/UssdSepToken`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${bearerToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ resNum }),
    });

    if (!response.ok) {
        throw new Error(`خطا در دریافت SepShareToken: ${response.status}`);
    }

    return response.json();
};


export const fetchSepShareTokenFlowUSSD = async (resNum: number | string) => {
    const clientRequestId = generateClientRequestId();
    const authData = await getAuthToken(clientRequestId);
    const sepData = await getSepShareToken(authData.access_token, resNum);
    return { clientRequestId, authData, sepData };
};
